'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import Script from 'next/script';
import React from 'react';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

const { locally } = publicRuntimeConfig;

// Declare Locally window functions
declare global {
  interface Window {
    lcly_config_0?: any;
    lcly_open_iframe?: () => void;
    __lcly_channel_domain_0?: string;
  }
}

interface Props {
  product?: {
    shop?: { upc?: string };
  };
}

const ShopLocalButton = ({ product }: Props) => {
  const { t } = useTranslation();
  const { geo } = useCurrentUrl();
  const lang = geo?.locale.toLowerCase();
  const country = geo?.country?.toUpperCase();

  const canBuyOnline = country === '/US' || country === '/CA';

  const config = React.useMemo(
    () => ({
      company_name: locally.companyName,
      button_text: t('productDetailPageContent.locallyButtonText', undefined, {
        default: 'Find in Store',
      }),
      button_id: 'HTML',
      company_id: String(locally.companyId),
      css: '3',
      enable_buy_online_button: canBuyOnline ? '1' : '0',
      n_buy_online_results: '3',
      upc: product?.shop?.upc ?? '',
      show_location_prompt: '1',
      lang: lang || 'en-US',
      n_dealers: '3',
      no_link: '1',
    }),
    [product?.shop?.upc, lang, canBuyOnline, t],
  );

  return (
    <div className="tw-w-full shop-local-button-style">
      <div
        id="lcly-button-0"
        data-switchlive="true"
        data-switchlive-impression="true"
        data-switchlive-impression-id-PL="1"
        className="shop-local-button-style"
        style={{ display: 'none' }}
      >
        <a
          id="lcly-link-0"
          data-switchlive="true"
          data-switchlive-mode="auto"
          data-switchlive-id-PL="6"
          role="button"
          href="https://join.locally.com/for-brands"
          target="_blank"
        ></a>
        <Script
          dangerouslySetInnerHTML={{ __html: `` }}
          id="lcly-script-0"
          async
          src={`https://traeger-grill.locally.com/stores/map.js?${new URLSearchParams(config)}`}
        />
        <Script
          src="https://traeger-grill.locally.com/js/switchlive.js?company_id=112256"
          id="lcly-script-switchlive-0"
          async
        />
        <Script
          dangerouslySetInnerHTML={{ __html: `` }}
          id="lcly-script-switchlive-events-0"
          src="https://traeger-grill.locally.com/switchlive/switchlive-events.js?company_id=112256"
          async
        />
      </div>
    </div>
  );
};

export default ShopLocalButton;
